var _rect, _rect2, _rect3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFitnessStudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#1E1E1E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -229.5,
    y: -119.5,
    width: 843,
    height: 839,
    fill: "#1F1F1F"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -229.5,
    y: -119.5,
    width: 843,
    height: 839,
    stroke: "#525252"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.01798 20.3051C3.14662 21.9196 8.05948 23.1871 10.3798 20.1645C12.8895 21.3649 17.029 20.9928 20.3992 19.1134C20.8679 18.8521 21.3113 18.5222 21.5828 18.0593C22.1958 17.0143 22.2103 15.5644 21.092 13.4251C19.2275 8.77072 15.8741 4.68513 14.5202 3.04212C14.2422 2.78865 12.4688 2.42868 11.3873 2.08279C10.9096 1.93477 10.0201 1.83664 8.95618 3.23862C8.45182 3.90329 6.16065 5.5357 9.06773 6.63346C9.51811 6.74806 9.84918 6.95939 11.9039 6.58404C12.1715 6.53761 12.8396 6.58404 13.3104 7.41041L14.2937 8.81662C14.3852 8.94752 14.4446 9.09813 14.4628 9.25682C14.6351 10.7557 14.6295 12.6323 15.4652 13.5826C14.1744 12.6492 10.8012 11.5406 8.25956 14.6951M2.00195 12.94C3.21015 11.791 6.71203 9.97592 10.418 12.5216",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFitnessStudio);
export default __webpack_public_path__ + "static/media/Fitness-studio.b920a76909912ec9d076cbaaa2109bad.svg";
export { ForwardRef as ReactComponent };